import { render } from "./OrganizationInvitationsDrawerPanel.vue?vue&type=template&id=6db05c3a&scoped=true"
import script from "./OrganizationInvitationsDrawerPanel.vue?vue&type=script&lang=js"
export * from "./OrganizationInvitationsDrawerPanel.vue?vue&type=script&lang=js"

import "./OrganizationInvitationsDrawerPanel.vue?vue&type=style&index=0&id=6db05c3a&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6db05c3a"]])

export default __exports__
import QExpansionItem from 'quasar/src/components/expansion-item/QExpansionItem.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QItem from 'quasar/src/components/item/QItem.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QExpansionItem,QIcon,QItem});
